import { LocalizedDateTime } from "../../components/LocalizedDate";
import { useAPI } from "../../hooks/APIHook";
import { useData } from "../../hooks/Data";
import { passthru } from "../../utils/validators";
import { API_ENDPOINTS } from "../../config";
import { SKTProgressBar } from "../../components/SKTProgressBar";
import { SKTPanel, SKTPanelBody } from "../../components/SKTPanel";
import { SKTTextField } from "../../components/SKTTextField";
import {
  SKTTable,
  SKTTableBody,
  SKTTableHeader,
} from "../../components/SKTTable";
import { useState } from "react";
import { css } from "../../components/SKT";

const OrderRow = ({ order }) => {
  const orderUrl = `/tilaus/?o=${order.secret}`;
  return (
    <tr>
      <td>
        <a href={orderUrl} rel="noreferrer" target="_blank">
          {order.number}
        </a>
      </td>
      <td>
        <LocalizedDateTime datetime={order.created} />
      </td>
      <td>{order.src.postal}</td>
      <td>{order.dst.postal}</td>
      <td>{order.contents.contents}</td>
      <td>{order.price.total.toFixed(2)} €</td>
    </tr>
  );
};

const SearchField = ({ value, setValue }) => {
  const onChange = (event) => {
    setValue(event.target.value);
    event.preventDefault();
  };
  return (
    <input
      className={css("form-control data")}
      id="order_search_"
      placeholder="Hae"
      type="text"
      value={value}
      onChange={onChange}
    />
  );
};

export const OrderList = () => {
  const [q, setQ] = useState("");
  const [ordersInfo] = useAPI(API_ENDPOINTS.profile.orders);
  if (ordersInfo.status === "pending")
    return (
      <SKTPanel>
        <SKTPanelBody>
          <SKTProgressBar label="Tilauksia haetaan" />
        </SKTPanelBody>
      </SKTPanel>
    );
  if (ordersInfo.status === "error") return <div>Virhe!</div>;
  if (ordersInfo.status === "no_auth") return <div>Ei kirjautunut sisään!</div>;

  const orders = ordersInfo.orders.filter((order) => {
    if (!q) return true;
    const ql = q.toLowerCase();
    const fieldMatch = (value) =>
      value ? value.toLowerCase().slice(0, ql.length) === ql : false;

    const contentsFieldMatch = (value) =>
      value ? value.toLowerCase().search(ql) !== -1 : false;

    const matchAddress = (a) => {
      return (
        fieldMatch(a.name) ||
        fieldMatch(a.addr) ||
        fieldMatch(a.name2) ||
        fieldMatch(a.postal)
      );
    };

    return (
      fieldMatch(order.number.toString()) ||
      matchAddress(order.src) ||
      matchAddress(order.dst) ||
      contentsFieldMatch(order.contents?.contents)
    );
  });

  return (
    <SKTPanel>
      <SKTPanelBody>
        <SearchField value={q} setValue={setQ} />
        <SKTTable>
          <SKTTableHeader>
            <tr>
              <th>Tilaus#</th>
              <th>pvm</th>
              <th>Mistä</th>
              <th>Minne</th>
              <th>Sisältö</th>
              <th>Hinta</th>
            </tr>
          </SKTTableHeader>
          <SKTTableBody>
            {orders.map((order) => (
              <OrderRow order={order} />
            ))}
          </SKTTableBody>
        </SKTTable>
      </SKTPanelBody>
    </SKTPanel>
  );
};
